export default __webpack_public_path__ + "static/media/invitationZh.33e85224.jpg";